export interface Color {
  r: number;
  g: number;
  b: number;
}

export abstract class ColorTable {
  private static color = [
    { r: 1, g: 0, b: 0 },
    { r: 0, g: 1, b: 0 },
    { r: 0, g: 0, b: 1 },
    { r: 1, g: 1, b: 0 },
    { r: 0, g: 1, b: 1 },
    { r: 1, g: 0, b: 1 },
    { r: 1, g: 1, b: 1 },
    { r: 0, g: 0, b: 1 },
    { r: 0, g: 0, b: 0 },
  ];

  public static getColor(i: number) {
    return this.color[i];
  }

  public static getRGBColor(i: number) {
    if (i > this.colorIndex()) {
      return { r: this.color[1].r, g: this.color[0].g, b: this.color[0].b };
    }

    return { r: this.color[i].r, g: this.color[i].g, b: this.color[i].b };
  }

  public static colorIndex() {
    return this.color.length - 1;
  }
}
